import { toCheckLocations } from "../../../../actions/Checks/checkSelection";
import { SUB_LAYER_ROWS, VIEW } from "../../../../actions/Layers/constants";
import FilterableConfigList from "./FilterableConfigList";
import { getLayerComponentForm, SUB_LAYER_ATTRIBUTES, useCheckLocationOptions } from "./LayerComponentConfigForm";

const defaultField = {
    field: {
        title: "",
        view: VIEW.CHILDREN,
        rows: SUB_LAYER_ROWS.CHILDREN,
        fields: [],
    }
};

// * show_tabs: a list of children tables (same settings as show_children), shown as tabs on the layer page.
// * Stored like dynamic_sections: [{ display_filter, field: <tab> }]
export default function SubLayerTabsConfigForm({ tabs, setTabs }) {
    const checkLocationOptions = useCheckLocationOptions();

    const getFieldForm = (object, setObject) => getLayerComponentForm(object ?? {}, setObject, checkLocationOptions)
        .filter((i) => SUB_LAYER_ATTRIBUTES.includes(i.name));

    const getFieldTitle = (object) => (
        <span>
            <b>{object?.title || "Tab"}</b>
            {object?.rows && ` - ${object.rows}`}
            {toCheckLocations(object?.filter_location).length > 0 && ` @ ${toCheckLocations(object.filter_location).join(", ")}`}
        </span>
    );

    return (
        <FilterableConfigList
            useDisplayFilter={["fruit_types", "exclude_fruit_types"]}
            name="show_tabs"
            title="Show tabs"
            description="Tabs on the layer page, each with its own children table. For example one tab with the outbound checks and one with the intake checks of the pallets."
            fields={tabs || []}
            setArray={setTabs}
            defaultField={defaultField}
            getFieldForm={getFieldForm}
            getFieldTitle={getFieldTitle}
        />
    );
}
